// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextButton_wrapper__xhIAD","underscored":"TextButton_underscored__8uIV0"};